<template>
  <div>
    <mainHeader></mainHeader>
    <testPortalBanner v-if="isTestPortal"></testPortalBanner>
    <div class="container-fluid">
      <sideMenu :studyData="studyData" :isTestPortal="isTestPortal"></sideMenu>
      <div class="content has-header has-sidemenu" :class="{ 'test-portal-padding-reset': isTestPortal }">
        <navBar :exact="false" class="ml-n-15 mr-n-15 mb-20" :routes="navBarRoutes" />
        <div v-if="studyData && !isEdroDashboard && toggleFeatures">
          <b-card class="header-study-information custom-card">
            <div class="open-header" :class="infoBodyStatus ? '' : ''">
              <span class="left-header">
                Study Information
              </span>

              <span class="middle-header">
                <span v-if="studyDuration > 0" class="progress-width">
                  <lineGraph
                    :options="{
                      type: 'single',
                      data: remainingDaysData,
                      color: '#48bf7a'
                    }"
                  ></lineGraph>
                </span>
                <span class="remaining_days_section fw-bold float-right">
                  <span v-if="studyData.status !== 'Close'" class="remaining_days_text">
                    <span v-if="daysRemaining >= 0"
                      ><span>{{ daysRemaining }}</span> days until end of study</span
                    >
                    <span v-if="daysRemainingStatus === 'notStarted'">Study has not yet begun</span>
                    <span v-if="daysRemainingStatus === 'ended'">Study has ended</span>
                  </span>
                  <span class="remaining_days_text" v-else>Study is closed</span>
                </span>
              </span>

              <span class="right-header" @click="infoBodyStatus = !infoBodyStatus">
                {{ infoBodyStatus ? "Hide" : "Show" }}
                <i class="fa" :class="infoBodyStatus ? 'fa-caret-up' : 'fa-caret-down'" aria-hidden="true"></i>
              </span>
            </div>
            <div class="info-body pt-1" :class="infoBodyStatus ? 'open-info-body' : ''">
              <b-row>
                <b-colxx xl="12" lg="12" md="12" class="p-0 text-center mb-10">
                  <div v-if="studyData.status === 'Active'">
                    <span class="fw-bold">Status:</span> Active
                    <a v-if="canSysAdminAccess || canStudyAdminAccess || canStudyManagerAccess" v-on:click="editStudy()" class="status-edit-button ml-5">
                      Edit
                    </a>
                  </div>
                  <div v-if="studyData.status === 'Draft'"><span class="fw-bold">Status:</span> Draft</div>
                  <div v-if="studyData.status === 'Complete' || studyData.status === 'Close'"><span class="fw-bold">Status:</span> Complete</div>
                </b-colxx>
                <b-colxx xl="5" lg="12" md="12" class="p-0">
                  <div class="line">
                    <span class="type width-3-span">Country(s):</span>
                    <span class="">{{ studyData.countryDisplay }}</span>
                  </div>
                  <div class="line">
                    <span class="type width-3-span">Language(s):</span>
                    <span class="">{{ studyData.languageDisplay }}</span>
                  </div>
                  <div class="line">
                    <span class="type width-3-span">Condition(s):</span>
                    <span class="">{{ studyData.conditionDisplay }}</span>
                  </div>
                  <div class="line">
                    <span class="type width-3-span">Rare disease study:</span>
                    <span v-if="studyData.rareDisease">Yes</span>
                    <span v-else>No</span>
                  </div>
                </b-colxx>
                <b-colxx xl="3" lg="12" md="12" class="p-0">
                  <div class="line">
                    <span class="type width-30">Study Design:</span>
                    <span class="width-70">{{ studyData.type }}</span>
                  </div>
                  <div class="line">
                    <span class="type width-2-span">Participants Expected:</span>
                    <span>{{ studyData.expectedPatients }}</span>
                  </div>
                  <div class="line">
                    <span class="type width-2-span">Study Start Date:</span>
                    <span>{{ getDateFormated(studyData.studyStartDate) }}</span>
                  </div>
                  <div class="line">
                    <span class="type width-2-span">Study End Date:</span>
                    <span>{{ getDateFormated(studyData.studyEndDate) }}</span>
                  </div>
                </b-colxx>
                <b-colxx xl="4" lg="12" md="12" class="p-0">
                  <div class="line">
                    <span class="type width-2-span">First Participant Enrolled:</span>
                    <span>{{ getDateFormated(studyData.firstPatientEnrollDate) }}</span>
                  </div>
                  <div class="line">
                    <span class="type width-60">First Participant's Last Day in Study:</span>
                    <span class="width-40">{{ getDateFormated(studyData.firstPatientLastDate) }}</span>
                  </div>
                  <div class="line">
                    <span class="type width-60">Last Participant Enrolled:</span>
                    <span class="width-40">{{ getDateFormated(studyData.lastPatientEnrollDate) }}</span>
                  </div>
                  <div class="line">
                    <span class="type width-60">Last Participant's Last Day in Study:</span>
                    <span class="width-40">{{ getDateFormated(studyData.lastPatientLastDate) }}</span>
                  </div>
                </b-colxx>
              </b-row>
            </div>
          </b-card>
        </div>
        <router-view :studyData="studyData" :studyId="studyId" :toggleFeatures="toggleFeatures" :complianceWidgets="complianceWidgetsStatus" v-if="complianceWidgetsStatus !== null"></router-view>
      </div>

      <div class="modal fade" id="activeModal" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header bb-none p-0">
              <span class="popup-status pt-10">Status:Active</span>
              <button type="button" class="close close-style" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div class="modal-body overflow">
              <div v-if="beforeAlert">
                <div class="row pt-10">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
                    <p class="text-justify pop-color">
                      Please confirm that you have received necessary organizational approval and IRB/EC approval to close this study.
                    </p>
                  </div>
                </div>
                <div class="row pt-10">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
                    <p class="color-azure text-justify">
                      <span class="">
                        <input type="checkbox" v-model="checkedAgreement" />
                      </span>
                      I have attained the proper approval from my IRB or EC board.
                    </p>
                  </div>
                </div>
                <div class="row pt-10">
                  <div class="col-3"></div>
                  <div class="col-6">
                    <button class="btn download_btn btn-block br-25" v-on:click="closeStudyAlert()" :disabled="!checkedAgreement">
                      Close study
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="afterAlert">
                <div class="row p-10">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p class="text-center pop-color">
                      Are you sure you want to close this study? This will prevent any new participants from enrolling and end all future participant data collection activities. This action will close your study.
                    </p>
                    <p class="text-center pop-color">
                      Your study data will still be available.
                    </p>
                  </div>
                </div>
                <div class="row p-10">
                  <div class="col-lg-4 col-lg-offset-4 col-md-4 col-md-offset-4 col-sm-4 col-sm-offset-4 col-xs-12">
                    <button class="btn close-btn btn-block br-25" v-on:click="closeStudy(studyData, 'Close')">
                      Close study
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mainHeader from "@/components/common/main-header";
import sideMenu from "@/components/common/side-menu";
import moment from "moment";
import lineGraph from "@/components/common/line-graph";
import { SYSTEM_ADMIN, STUDY_ADMIN, STUDY_MANAGER } from "@/constants/authRoles";
import { mapGetters } from "vuex";
import toastr from "toastr";
import _ from "lodash";
import { AclRule } from "vue-acl";
import navBar from "@/components/common/nav-bar";
import { EDRO_DASHBOARD_ROUTE_NAMES } from "@/constants/edroDashboardRoutes";
import localStorageService from "@/services/localStorage";
import testPortalBanner from "@/components/common/test-portal-banner";
import { TEST_PORTAL_SUFFIX } from "@/constants/config";

export default {
  components: {
    mainHeader,
    sideMenu,
    lineGraph,
    navBar,
    testPortalBanner
  },
  data() {
    return {
      studyData: {},
      infoBodyStatus: false,
      studyId: this.$route.params.studyId,
      studyDuration: null,
      daysRemaining: null,
      daysRemainingStatus: null,
      remainingDaysData: null,
      afterAlert: false,
      beforeAlert: true,
      checkedAgreement: null,
      navBarRoutes: [],
      toggleFeatures: [],
      complianceWidgetsStatus: null
    };
  },
  computed: {
    // studyId() {
    //   return this.$route.params.studyId;
    // },
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    },
    isEdroDashboard() {
      if (EDRO_DASHBOARD_ROUTE_NAMES.includes(this.$route.name)) {
        return true;
      }
      return false;
    }
  },
  methods: {
    getStudyDetails() {
      let studyDetails = localStorageService.getItem("studyDetailsData")[this.studyId] || {};
      if(studyDetails){
        this.studyData = studyDetails;
      }
      else{
        this.$api.getStudyDataFact(this.studyId).then(response => {
          this.studyData = response.body;
        });
      }
      this.studyData.countryList.forEach((country, i) => {
        const countryName = (this.studyData.countryList.length - 1 == i) ? country.countryName : country.countryName + ',';
        this.studyData.countryDisplay = this.studyData.countryDisplay ? this.studyData.countryDisplay + ' ' + countryName : countryName;
      })
      this.studyData.language.forEach((language, i) => {
        const languageName = (this.studyData.language.length - 1 == i) ? language.display_name : language.display_name + ',';
        this.studyData.languageDisplay = this.studyData.languageDisplay ? this.studyData.languageDisplay + ' ' + languageName : languageName;
      })
      this.studyData.targetPatients.forEach((condition, i) => {
        const conditionName = (this.studyData.targetPatients.length - 1 == i) ? condition : condition + ',';
        this.studyData.conditionDisplay = this.studyData.conditionDisplay ? this.studyData.conditionDisplay + ' ' + conditionName : conditionName;
      })
      this.getRemainingDays();
    },
    async getBrandingDetails() {
      try {
        const data = await this.$api.getBrandingDetailsFact(this.studyId);
        if (data.ok) {
          return data.body;
        } else {
          return null;
        }
      } catch (err) {
        return null;
      }
    },
    getDateFormated(date) {
      const d = new Date(date);
      return date
        ? moment
            .utc(d)
            .format("DD MMM YYYY")
            .toUpperCase()
        : "-";
    },
    getRemainingDays() {
      const sd = this.getExactDayEpoch(this.studyData.studyStartDate);
      const ed = this.getExactDayEpoch(this.studyData.studyEndDate);
      const today = this.getExactDayEpoch(new Date());
      this.studyDuration = Math.ceil(Math.abs(ed - sd) / (1000 * 3600 * 24));
      if (sd > today) {
        this.daysRemaining = -1;
        this.daysRemainingStatus = "notStarted";
        this.remainingDaysData = 0;
      } else if (today >= sd && today <= ed) {
        this.daysRemaining = Math.ceil(Math.abs(ed - today) / (1000 * 3600 * 24));
        const averageDays = (this.daysRemaining / this.studyDuration) * 100;
        this.remainingDaysData = 100 - averageDays;
        this.daysRemainingStatus = "inProgress";
      } else if (today > sd && today > ed) {
        this.daysRemaining = -1;
        this.daysRemainingStatus = "ended";
        this.remainingDaysData = 100;
      }
    },
    getExactDayEpoch(day) {
      const dayNew = new Date(day);
      return new Date(dayNew.getFullYear(), dayNew.getMonth(), dayNew.getDate(), 0, 0, 0).getTime();
    },
    editStudy() {
      if (this.user.userRole !== "Pi") {
        window.$("#activeModal").modal("show");
      } else {
        toastr.warning("Access restricted");
      }
    },
    closeStudyAlert() {
      this.beforeAlert = false;
      this.afterAlert = true;
    },
    closeStudy(studyData, studyStatus) {
      window.$("#activeModal").modal("hide");
      this.beforeAlert = true;
      this.afterAlert = false;
      this.$api.deleteStudyFact(studyData.studyId, studyStatus).then(
        response => {
          toastr.success(response.data.message);
          this.getStudyDetails();
        },
        error => {
          toastr.error(error.message);
        }
      );
    },
    async getNavBarRoutes() {
      this.navBarRoutes.push({
        label: "Analytics",
        to: { name: `${this.isTestPortal ? TEST_PORTAL_SUFFIX : ""}analytics`, params: { studyId: this.studyId } }
      });
      try {
        const res = await this.$api.getToggleFeaturesFact(this.studyId);
        if (res.ok) {
          const results = res.body.studyFeatures;
          this.toggleFeatures = res.body.studyFeatures;

          const complianceWidgetsStatus = _.find(this.toggleFeatures, toggleFeature => {
            return toggleFeature.featureKey === "ANALYTICS_DASHBOARD_COMPLIANCE_WIDGET";
          });
          if ((complianceWidgetsStatus && complianceWidgetsStatus.enabled) || complianceWidgetsStatus === undefined) {
            this.complianceWidgetsStatus = true;
          } else {
            this.complianceWidgetsStatus = false;
          }
          results.forEach(result => {
            if (result.featureKey == "eDRODashboard") {
              if (this.user.userRole != "Quality" && this.user.userRole != "Pharmacovigilance" && this.user.userRole != "Interviewer" && this.user.userRole != "Rater") {
                this.navBarRoutes.push({
                  label: "eDRO",
                  to: {
                    name: `${this.isTestPortal ? TEST_PORTAL_SUFFIX : ""}edro-forced-spirometry`,
                    params: { studyId: this.studyId }
                  }
                });
              }
            }
          });
        }
      } catch (err) {}
    }
  },
  async mounted() {
    document.body.classList.add("analytics-custom");
    const studyColor = await this.getBrandingDetails();
    if (studyColor) {
      document.querySelector(":root").style.setProperty("--study-primary-color", studyColor.colorPrimary);
      document.querySelector(":root").style.setProperty("--study-secondary-color", studyColor.colorSecondary);
    }
    this.getStudyDetails();
    this.getNavBarRoutes();
  },
  destroyed() {
    document.body.classList.remove("analytics-custom");
  },
  props: {
    isTestPortal: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.remaining_days_text {
  color: var(--study-primary-color);
}

.middle-header {
  display: flex;
  justify-content: center;
  width: 50%;
  align-items: center;
}

.progress-width {
  width: 60%;
}

.line_graph .single_main {
  height: 8px !important;
}

.line_graph .data {
  height: 8px !important;
}

.remaining_days_section {
  margin-left: 1rem;
  font-size: 14px;
}

.width-30 {
  width: 90px !important;
}

.width-40 {
  width: calc(100% - 210px) !important;
}

.width-60 {
  width: 210px !important;
}

.width-70 {
  width: calc(100% - 120px) !important;
}

.width-2-span {
  width: 150px !important;
}
.width-2-span + span {
  width: calc(100% - 150px) !important;
}
.width-3-span {
  width: 115px !important;
}
.width-3-span + span {
  width: calc(100% - 115px) !important;
}
.modal-dialog {
  max-width: 600px !important;
}

.popup-status {
  color: #2d3752;
  font-weight: bold;
  position: fixed;
  top: 10px;
  left: 20px;
}

.pop-color {
  color: #666669 !important;
}

.color-azure {
  color: #1f95f2 !important;
}

.download_btn {
  background-color: #4c8ce4;
  color: #ffffff;
  cursor: pointer;
}

.close-btn {
  background: #d3dfe4;
  color: #666669;
}

.status-edit-button {
  border: 1px solid #007bff;
  padding: 2px 12px;
  color: #007bff !important;
  cursor: pointer;
  border-radius: 4px !important;

  &:hover {
    background-color: #007bff;
    color: #fff !important;
  }
}

.close-style {
  padding-right: 30px !important;
  padding-top: 25px !important;
}

.ml-n-15 {
  margin-left: -15px !important;
}

.mr-n-15 {
  margin-right: -15px !important;
}
</style>
